export const reviews = [
  {
    id: 1,
    navn: "Morten Schmidt",
    rolle: "Sommerhusejer, Ebeltoft",
    rating: 5,
    titel: "Fantastisk resultat!",
    tekst: "Tømrerfirmaet RNS udførte en komplet renovering af vores sommerhus i Ebeltoft. Resultatet blev fantastisk! Særligt den nye træterrasse er i absolut topklasse. Professionel dialog hele vejen igennem."
  },
  {
    id: 2,
    navn: "Kirsten Poulsen",
    rolle: "Husejer, Grenaa",
    rating: 5,
    titel: "Flot stykke arbejde",
    tekst: "Vi fik udskiftet alle vinduer i vores parcelhus. RNS leverede et utrolig flot stykke arbejde, og de ryddede pænt op efter sig hver dag. Varmeregningen er allerede faldet!"
  },
  {
    id: 3,
    navn: "Jesper Hansen",
    rolle: "Erhvervsdrivende, Balle",
    rating: 5,
    titel: "Super professionelt",
    tekst: "Super professionelt tømrerfirma. De stod for ombygningen af vores butikslokaler, og alt blev leveret til tiden og inden for budgettet. Kan varmt anbefales!"
  },
  {
    id: 4,
    navn: "Hanne & Peter",
    rolle: "Sommerhusejere, Fjellerup Strand",
    rating: 5,
    titel: "Sans for detaljen",
    tekst: "RNS har renoveret vores sommerhus med sans for detaljen og respekt for husets oprindelige stil. De kombinerede traditionelt håndværk med moderne løsninger på bedste vis."
  },
  {
    id: 5,
    navn: "Thomas Nielsen",
    rolle: "Husejer, Rønde",
    rating: 5,
    titel: "Yderst tryg proces",
    tekst: "Fik lavet tagrenovering af Tømrerfirmaet RNS. De var meget grundige i deres forarbejde og rådgivning. Taget ser ud som nyt, og hele processen var yderst tryg."
  }
];

export const usps = [
  {
    title: "Høj Håndværksmæssig Kvalitet",
    description: "Vi kombinerer det gode traditionelle håndværk med moderne teknikker for at sikre et holdbart resultat.",
    icon: "fa-solid fa-award"
  },
  {
    title: "Lokal Forankring",
    description: "Med base i Glatved kender vi Djursland, Ebeltoft og Grenaa ud og ind. Vi er altid tæt på dig.",
    icon: "fa-solid fa-map-location-dot"
  },
  {
    title: "Tæt Dialog & Aftaler",
    description: "Vi vægter den gode, åbne dialog højt. Vi leverer altid til aftalt tid, pris og kvalitet.",
    icon: "fa-solid fa-comments"
  },
  {
    title: "Komplette Løsninger",
    description: "Vi tilbyder både tømrer- og malerarbejde, så du kun behøver én samarbejdspartner til dit projekt.",
    icon: "fa-solid fa-house-laptop"
  }
];
